import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent'
import styles from './styles.module.sass'
import {popupDel, popupHide, popupShowHidden} from 'actions/popup';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import cx from 'classnames';

const CLOSE_TIMEOUT = 2000;
const CLOSE_ANIMATION_TIMEOUT = 1000;

const mapStateToProps = state => ({
  popup: state.popup
});

@connect(mapStateToProps)
class Popup extends PureComponent {
  static display = {
    error: 'error',
    warning: 'warning',
    info: 'info',
    success: 'success'
  };

  handleClose = () => {
    this.setState({open: false});
  };

  data = {
    closeDelay: true,
    closeTaskId: null,
    delTaskId: null,
  };


  componentWillReceiveProps(nextProps) {
    const {popup: {stack}} = nextProps;

    if (!this.data.closeTaskId && stack && stack.length > 0 && this.data.closeDelay) {
      this.closeDelay();
    }
  }

  delDelay = () => {
    const {dispatch} = this.props;
    const th = this;
    this.data.delTaskId = setTimeout(() => {
      th.data.delTaskId = null;
      dispatch(popupDel());
    }, CLOSE_ANIMATION_TIMEOUT);
  };

  closeDelay = () => {
    const {dispatch} = this.props;
    if (this.data.closeTaskId) {
      clearTimeout(this.data.closeTaskId);
      this.data.closeTaskId = null;
    }

    const th = this;
    this.data.closeTaskId = setTimeout(() => {
      th.data.closeTaskId = null;
      dispatch(popupHide()).then(() => th.delDelay());
    }, CLOSE_TIMEOUT);
  };

  handlerOnMouseEnter = () => {
    const {dispatch} = this.props;

    if (this.data.closeTaskId || this.data.delTaskId) {
      if (this.data.closeTaskId) {
        clearTimeout(this.data.closeTaskId);
        this.data.closeTaskId = null;
      }

      if (this.data.delTaskId) {
        clearTimeout(this.data.delTaskId);
        this.data.delTaskId = null;
      }

      this.data.closeDelay = false;
      dispatch(popupShowHidden());
    }
  };

  handlerOnMouseLeave = () => {
    this.data.closeDelay = true;
    this.closeDelay();
  };

  render() {
    const {dispatch, popup: {stack = []}} = this.props;
    if (stack.length <= 0) return null;

    const renderIcon = (display) => {
      switch (display) {
        case Popup.display.info:
          return (<div><InfoIcon/></div>);
        case Popup.display.warning:
          return (<div><WarningIcon/></div>);
        case Popup.display.error:
          return (<div><ErrorIcon/></div>);
        case Popup.display.success:
          return (<div><CheckCircleIcon/></div>);
      }
    };

    return (
      <Snackbar
        anchorOrigin={{vertical: 'top', horizontal: 'right'}}
        open={true}
        onMouseEnter={() => this.handlerOnMouseEnter()}
        onMouseLeave={() => this.handlerOnMouseLeave()}
      >
        <div className={styles.contentBox}>
          {stack.map(popup => (
            <div key={popup.key}>
              <SnackbarContent
                className={cx(
                  styles.content,
                  {[styles.softDel]: popup.softDel === true},
                  {[styles.showSoftDel]: popup.softDel === false},
                  {[styles.success]: popup.display === Popup.display.success},
                  {[styles.error]: popup.display === Popup.display.error},
                  {[styles.info]: popup.display === Popup.display.info},
                  {[styles.warning]: popup.display === Popup.display.warning}
                )}
                message={(
                  <div id={popup.key} className={styles.messageWrapper}>
                    {renderIcon(popup.display)}
                    <div className={styles.messageBox}>
                      <div className={styles.message}>{popup.message}</div>
                      {popup.text && <pre className={cx(styles.text, {[styles.textSoftDel]: popup.softDel})}>{popup.text}</pre>}
                    </div>
                    <IconButton
                      key='close'
                      className='info'
                      aria-label='Close'
                      color='inherit'
                      onClick={() => dispatch(popupDel(popup.key))}
                    >
                      <CloseIcon/>
                    </IconButton>
                  </div>
                )}
              />
            </div>
          ))}
        </div>
      </Snackbar>
    )
  }
}

Popup.propTypes = {
  popup: PropTypes.objectOf({
    stack: PropTypes.arrayOf({
      key: PropTypes.string,
      message: PropTypes.string,
      display: PropTypes.oneOf([Popup.display.success, Popup.display.warning, Popup.display.error, Popup.display.info]),
      softDel: PropTypes.bool
    })
  })
};


export default Popup;


// WEBPACK FOOTER //
// ./src/components/common/Popup/Popup.jsx